/**
 * Contexto de trabajo declarado por la pantalla actual (REQ-044 §27): proyecto/tarea visibles.
 * Solo identificadores y módulo. Las pantallas lo fijan con useWorkContext y lo liberan al desmontarse.
 */
import { useEffect } from 'react';
import { create } from 'zustand';

export interface WorkContextValue { module?: string; projectId?: string; taskId?: string }

interface State { value: WorkContextValue | null; set: (v: WorkContextValue | null) => void }
export const useWorkContextStore = create<State>()((set) => ({ value: null, set: (value) => set({ value }) }));

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
export const isUuid = (s: string | null | undefined): s is string => !!s && UUID.test(s);

/** Pantallas con proyecto/tarea identificables: llamar con los ids actuales (undefined = sin contexto). */
export function useWorkContext(module: string, projectId?: string | null, taskId?: string | null) {
  const set = useWorkContextStore((s) => s.set);
  useEffect(() => {
    set({ module, projectId: isUuid(projectId) ? projectId : undefined, taskId: isUuid(taskId) && isUuid(projectId) ? taskId : undefined });
    return () => set(null);
  }, [module, projectId, taskId, set]);
}

/** Contexto por defecto desde la ruta: /proyectos/:id. */
export function contextFromPath(pathname: string): WorkContextValue {
  const m = /^\/proyectos\/([^/]+)/.exec(pathname);
  const module = pathname.split('/')[1] || 'inicio';
  return { module: /^[a-z0-9-]{1,40}$/.test(module) ? module : 'inicio', projectId: m && isUuid(m[1]) ? m[1] : undefined };
}
